module.exports = "/packs/images/svg/facilities/health_suite~14fa78b7b447a019fc00ad1c308d4970.svg";